<template>
  <div>
    <!--Route Related Geographies-->
    <template v-for="route in routes">
      <gmap-polyline
        :key="`r-${route.id}`"
        :path="getPath(route)"
        :options="getPathOptions(route)"
        @click="openRoute(route.id)"
      ></gmap-polyline>

      <gmap-marker
        v-for="stop in route.Stops"
        :key="`stop-${stop.id}`"
        :position="stop.point"
        :icon="getIcon('Stop', stop)"
        @click="openServiceStop(stop)"
      ></gmap-marker>
    </template>

    <gmap-marker
      v-for="location in hubs"
      :key="`cl-${location.id}`"
      :position="location.point"
      :icon="getIcon('CollectionLocation', location)"
      @click="openHub(location.id)"
      v-if="location && location.point"
    ></gmap-marker>

    <gmap-marker
      v-for="location in locations"
      :key="`pl-${location.location.id}`"
      :position="location.location.point"
      :icon="getIcon(location.type, location.entity)"
      :options="{ zIndex: getIcon(location.type, location.entity).zIndex }"
      v-if="location && location.location.point"
      @click="openLocation(location)"
    ></gmap-marker>
  </div>
</template>

<script>
import * as MapperHelpers from '../MapperHelpers'

export default {
  name: 'RouteMapperOverview',

  props: [
    'status',
    'routes',
    'locations',
    'hubs'
  ],

  methods: {
    getIcon: MapperHelpers.getIcon,
    getPath: MapperHelpers.getPath,
    getPathOptions: MapperHelpers.getPathOptions,

    openRoute (id) {
      let routeData = this.$router.resolve({ name: 'View Route', params: { id }});
      window.open(routeData.href, '_blank');
    },

    openHub (id) {
      let routeData = this.$router.resolve({ name: 'View Collection Location', params: { id }});
      window.open(routeData.href, '_blank');
    },
    
    openServiceStop (stop) {
      if (stop && stop.serviceStop) {
        if (stop.serviceStop.pickupRequestId) {
          let routeData = this.$router.resolve({
            name: 'View Pickup Request',
            params: { id: stop.serviceStop.pickupRequestId },
            query: { load: 'pickupLocation' }
          });
          window.open(routeData.href, '_blank');
        } else {
          let routeData = this.$router.resolve({ name: 'View Pickup Location', params: { id: stop.serviceStop.pickupLocationId }});
          window.open(routeData.href, '_blank');
        }
      }
    },

    openLocation (location) {
      if (location.entity === location.location) {
        let routeData = this.$router.resolve({ name: 'View Pickup Location', params: { id: location.location.id }});
        window.open(routeData.href, '_blank');
      } else {
        let routeData = this.$router.resolve({
            name: 'View Pickup Request',
            params: { id: location.entity.id },
            query: { load: 'pickupLocation' }
          });
        window.open(routeData.href, '_blank');
      }
    }
  }
}
</script>
